import { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Error } from "@churchofjesuschrist/eden-alert";
import { ProgressSection } from "@churchofjesuschrist/eden-progress";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { Play } from "@churchofjesuschrist/eden-icons";
import Image from "@churchofjesuschrist/eden-image";
import { black, spacing16, white } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Root = styled.div.withConfig({
  componentId: "sc-bvqtyr-0"
})(["aspect-ratio:16/9;width:100%;background:", ";"], black);

// The video-js element is for Brightcove's player
const InnerLayout = styled.div.withConfig({
  componentId: "sc-bvqtyr-1"
})(["position:relative;width:100%;height:100%;overflow:hidden;& iframe,& object,& embed,& video,& video-js,& > *{position:absolute;height:100%;width:100%;top:0;left:0;}"]);
const Poster = styled.div.withConfig({
  componentId: "sc-bvqtyr-2"
})(["z-index:3;display:flex;align-items:flex-end;padding:", ";background:", ";& img,& picture{position:absolute;height:100%;width:100%;top:0;left:0;object-fit:cover;}"], spacing16, black);
const PlayButton = styled(Icon).withConfig({
  componentId: "sc-bvqtyr-3"
})(["z-index:1;background:", ";"], white);
const ErrorMessage = styled(Error).withConfig({
  componentId: "sc-bvqtyr-4"
})(["z-index:2;overflow:scroll;"]);
const Loading = styled.div.withConfig({
  componentId: "sc-bvqtyr-5"
})(["z-index:4;width:100%;height:100%;display:flex;justify-content:center;align-items:center;"]);
const Layout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    loading,
    error,
    poster,
    play,
    children,
    playLabel,
    hasParentPoster,
    // private prop used by failover to inform if that parent wrapper is handling the poster for the multiple videos
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Root, {
    ...props,
    ref: ref,
    children: /*#__PURE__*/_jsxs(InnerLayout, {
      children: [poster && !error && !hasParentPoster ? /*#__PURE__*/_jsxs(Poster, {
        onClick: play,
        children: [typeof poster === "string" ? /*#__PURE__*/_jsx(Image, {
          src: poster
        }) : poster, /*#__PURE__*/_jsx(PlayButton, {
          "aria-label": playLabel,
          children: /*#__PURE__*/_jsx(Play, {})
        })]
      }) : undefined, error ? /*#__PURE__*/_jsx(ErrorMessage, {
        children: error
      }) : children, loading ? /*#__PURE__*/_jsx(Loading, {
        children: /*#__PURE__*/_jsx(ProgressSection, {})
      }) : null]
    })
  });
});
Layout.displayName = "Layout";
export default Layout;
Layout.propTypes = {
  /** The video player element */
  children: PropTypes.node,
  /** A poster image element or image source URL */
  poster: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Error message to display. Not using this props assumes no current error. */
  error: PropTypes.node,
  /** Whether the player is currently loading */
  loading: PropTypes.bool,
  /** Function to call to play the video */
  play: PropTypes.func,
  /** Play button label */
  playLabel: PropTypes.string
};